import { render, staticRenderFns } from "./PolicyContactInfoSection.vue?vue&type=template&id=737662d2&scoped=true&"
import script from "./PolicyContactInfoSection.vue?vue&type=script&lang=js&"
export * from "./PolicyContactInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./PolicyContactInfoSection.vue?vue&type=style&index=0&id=737662d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737662d2",
  null
  
)

export default component.exports